import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import HTMLFlipBook from 'react-pageflip';
import '../styles/ManualsView.css';

// Configure the pdfjs worker (using a locally installed version or serving from public)
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

class ManualDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      scale: 1.0, // initial zoom level (100%)
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  handleZoomIn = () => {
    this.setState((prevState) => ({ scale: prevState.scale + 0.2 }));
  };

  handleZoomOut = () => {
    this.setState((prevState) => ({ scale: Math.max(prevState.scale - 0.2, 0.5) }));
  };

  render() {
    const { id } = this.props.match.params;
    const pdfUrl = `/manuals/${id}.pdf`;
    const { numPages, scale } = this.state;

    // Extract readable name from id (e.g. "ManualCash_es" -> "Cash (ES)")
    const nameMatch = id.match(/^Manual(.+?)_(es|en)$/i);
    const displayName = nameMatch
      ? `${nameMatch[1].replace(/([A-Z])/g, ' $1').trim()} (${nameMatch[2].toUpperCase()})`
      : id;

    // Generate an array of pages using the current scale
    const pages = [];
    if (numPages) {
      for (let i = 1; i <= numPages; i++) {
        pages.push(
          <div key={i}>
            <Page pageNumber={i} scale={scale} />
          </div>
        );
      }
    }

    return (
      <div className="manual-details-view">
        {/* Admin Header */}
        <div className="mn-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-book-open mr-2"></i>
                {displayName}
              </h1>
            </div>
            <div className="header-actions">
              <button
                className="mn-admin-btn info"
                onClick={() => window.open(pdfUrl, '_blank')}
              >
                <i className="fas fa-external-link-alt"></i>
                <span>Abrir en nueva pestaña</span>
              </button>
              <Link to="/manuals" className="mn-admin-btn primary">
                <i className="fas fa-arrow-left"></i>
                <span>Volver</span>
              </Link>
            </div>
          </div>
        </div>

        {/* PDF Viewer Card */}
        <div className="manual-pdf-wrapper">
          <div className="manual-pdf-header">
            <i className="fas fa-file-pdf"></i>
            Visor de Manual — {numPages ? `${numPages} páginas` : 'Cargando...'}
          </div>
          <div className="manual-pdf-body">
            <Document file={pdfUrl} onLoadSuccess={this.onDocumentLoadSuccess}>
              {numPages && (
                <HTMLFlipBook
                  width={600 * scale}
                  height={850 * scale}
                  showCover={false}
                >
                  {pages}
                </HTMLFlipBook>
              )}
            </Document>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
});

export default connect(mapStateToProps)(ManualDetailsView);
